/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import io from 'socket.io-client';
export const appConstants = {
    socket: io(process.env.REACT_APP_URL),
    paAppURL: process.env.REACT_APP_URL,
    s3UploadUrl: process.env.REACT_APP_S3_UPLOAD_URL,
    PswValidCharecters: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{6,12}$/
};

